import React, { useState, useEffect } from 'react';
import '../styles/ScrollTop.css';
import '../styles/Modal.css';
import { FiArrowUpCircle } from 'react-icons/fi';

export const ButtonScrollTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <div
      className={`scroll-to-top ${isVisible ? 'show' : 'hide'}`}
      onClick={scrollToTop}
    >
      <FiArrowUpCircle className='scroll-button' />
    </div>
  );
};

export const ButtonContinueRead = (props) => {
  const scrollToAyat = () => {
    const element = document.getElementById(props.ayat);
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
    element.style.border = '2px solid #ffaa00';
  };

  return (
    <a
      href={'#' + props.ayat}
      className='modal-from-saved__link'
      onClick={(e) => {
        e.preventDefault();
        scrollToAyat();
      }}
    >
      {props.name}
    </a>
  );
};
